import type { ToursFiltersRequest, ToursFiltersState } from "../types/filters";

// Маппер из state формы в тело запроса (POST /search).
export const mapFiltersToRequest = (
  filters: ToursFiltersState
): ToursFiltersRequest => ({
  date: {
    delta: 0,
    from: filters.dateFrom,
    to: filters.dateTo,
  },
  is_direct: filters.isDirect ?? false,
  is_round_trip: filters.isRoundTrip ?? false,
  price: {
    from: Number(filters.priceFrom) || 0,
    to: Number(filters.priceTo) || 0,
  },
  trips: [{ from: filters.tripsFrom, to: filters.tripsTo }],
});
